function ansiWordBound(c) {
    return (
        (' ' === c) ||
        ('\n' === c) ||
        ('\r' === c) ||
        ('\t' === c)
    )
}

function numberOfWords(text) {
    let words = 0;
    let start = 0;
    let end = text.length - 1;
    let wordBound, i;

// use provided function if available
    wordBound = ansiWordBound;

// fetch bounds
    while (wordBound(text[start])) start++;
    while (wordBound(text[end])) end--;

// calculate the number of words
    for (i = start; i <= end;) {
        for (; i <= end && !wordBound(text[i]); i++) ;
        words++;
        for (; i <= end && wordBound(text[i]); i++) ;
    }
    return words;
}


function readingTime(text) {
    const wordsPerMinute = 200;
    let words = 0;
    for (const child of text.props.children) {
        if (child.type.displayName && child.type.displayName.indexOf("Paragraph") !== -1) {
            if (typeof child.props.children === 'string') {
                words += numberOfWords(child.props.children);
            } else {
                if (typeof child.props.children === 'object') {
                    for (const grandChild of child.props.children) {
                        if (typeof grandChild === 'string') {
                            words += numberOfWords(grandChild);
                        }
                    }
                }
            }
        }
    }

    // reading time stats
    let minutes = words / wordsPerMinute;
    return Math.ceil(minutes.toFixed(2));
}

export {readingTime};
